import Cookies from "universal-cookie";

const cookies = new Cookies(null, { path: "/" });

export const setCookies = (name, value, options) =>
  cookies.set(name, value, { path: "/", ...options });
export const getCookies = (name) => cookies.get(name);
export const removeCookies = (name) => cookies.remove(name);

export const removeAllCookies = () => {
  document.cookie
    .split(";")
    .forEach(
      (c) =>
        (document.cookie = c
          .replace(/^ +/, "")
          .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`))
    );
};
